// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Visible = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      d="M9 4.5C5.938 4.5 3.313 6.136 2 9c1.313 2.864 3.938 4.5 7 4.5 3.063 0 5.688-1.636 7-4.5-1.312-2.864-3.937-4.5-7-4.5Z"
    />
    <path stroke="currentColor" d="M11.5 9a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />
  </svg>
);
const ForwardRef = forwardRef(Visible);
export default ForwardRef;
